<ui-content-header title="Email Templates" type="page">
	<ui-button
		title-action
		label="New Template"
		preset="MEDIUM_EMPHASIS"
		icon="plus"
		(click)="onNewTemplate()"
	/>
	@if (viewModel_().canEditCloserEmailTemplates) {
		<ui-button
			actions
			label="New Closer Global Template"
			preset="MEDIUM_EMPHASIS"
			icon="plus"
			(click)="onNewCloserGlobalTemplate()"
		/>
	}
</ui-content-header>

<div class="flex flex-col bg-white rounded-2xl divide-y divide-gray-200">
	<div class="grid grid-cols-4 gap-4 p-4">
		<div class="flex flex-col">
			<label class="p-sm mb-2">Search</label>
			<div class="relative">
				<i-tabler
					name="search"
					class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
				></i-tabler>
				<input
					#searchInput
					placeholder="Template name"
					class="p-sm pl-8 pr-4 py-2 rounded-md border border-gray-200 w-full focus:outline-green placeholder:text-gray-500"
				/>
				<ui-button
					preset="ICON_DEFAULT"
					size="xs"
					icon="x"
					class="absolute right-2 top-1/2 -translate-y-1/2"
					classes="!px-1 !py-1"
				>
				</ui-button>
			</div>
		</div>
		<div>
			<ui-select label="File Type" [options]="FILE_TYPE_OPTIONS" />
		</div>
		<div>
			<ui-select
				label="Email Recipient"
				[options]="EMAIL_RECIPIENT_TYPE_OPTIONS"
			/>
		</div>
		<div>
			<ui-select label="Created By" [options]="clientOptions_()" />
		</div>
	</div>
	<div class="grid grid-cols-12 gap-4 p-4 bg-gray-50">
		<div class="col-span-5">
			<p class="p-sm font-medium">Template Name</p>
		</div>
		<div class="col-span-3">
			<p class="p-sm font-medium">Email Recipient Type</p>
		</div>
		<div class="col-span-1">
			<p class="p-sm font-medium">File Type</p>
		</div>
		<div class="col-span-2">
			<p class="p-sm font-medium">Created By</p>
		</div>
		<div class="col-span-1"></div>
	</div>
	@if (templatesWithDropdownItems_().length > 0) {
		<div class="divide-y divide-gray-200">
			@for (template of templatesWithDropdownItems_(); track template.id) {
				<div
					class="grid grid-cols-12 gap-4 p-4 items-center hover:bg-gray-50 duration-300 cursor-pointer"
					(click)="onSelectTemplate(template.id)"
				>
					<p class="p-sm col-span-5">
						{{ template.templateName }}
						@if (template.default) {
							<span
								class="ml-2 p-sm text-xs text-gray-700 py-1.5 px-3 bg-gray-50 rounded-md"
								>Default</span
							>
						}
					</p>
					<p class="p-sm col-span-3">
						{{ template.emailRecipientType | titlecase }}
					</p>
					<p class="p-sm col-span-1">
						<ng-container
							*ngTemplateOutlet="
								fileTypeTemplate;
								context: { $implicit: template.fileType }
							"
						></ng-container>
					</p>
					<p class="p-sm col-span-2">
						@if (template.source === 'global') {
							<span
								class="p-sm text-xs text-gray-700 py-1.5 px-3 bg-gray-50 rounded-md"
								>Closer</span
							>
						} @else {
							{{ template.createdByUser?.firstName }}
							{{ template.createdByUser?.lastName }}
						}
					</p>
					<p class="p-sm col-span-1 flex justify-end">
						<ui-dropdown
							[items]="template.dropdownItems"
							(click)="$event.stopPropagation()"
						>
							<ui-button preset="ICON_DEFAULT" icon="dots-vertical" />
						</ui-dropdown>
					</p>
				</div>
			}
		</div>
	} @else {
		<div class="px-4 py-12 flex justify-center items-center">
			<p class="p-sm text-gray-500">No templates found</p>
		</div>
	}
</div>

<ng-template #fileTypeTemplate let-value>
	<span
		class="inline-flex items-center justify-center w-6 h-6 rounded-md text-white text-xs font-medium"
		[ngClass]="{
			'bg-blue-500': value === MATTER_FILE_TYPES.PURCHASE,
			'bg-yellow-500': value === MATTER_FILE_TYPES.SALE,
			'bg-purple-700': value === MATTER_FILE_TYPES.REFINANCE,
		}"
	>
		{{ value?.charAt(0)?.toUpperCase() }}
	</span>
</ng-template>
